import { Component, input, output } from "@angular/core";
import { EvAccordionComponent } from "ev-accordion";
import { AccordionStateClass } from "src/app/infopage/models/accordion-state.class";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";

@Component({
    selector: "sub-accordion",
    templateUrl: "./sub-accordion.component.html",
    styleUrl: "./sub-accordion.component.scss",
    imports: [EvAccordionComponent, EvLogoLoaderComponent],
})
export class SubAccordionComponent {
    accordionState = input.required<AccordionStateClass<any>>();
    toggled = output<boolean>();

    expanderClicked(): void {
        this.accordionState().expanderClicked();
    }
}
